// OpenAI Ads Conversions API: capture oppref and persist it to Shopify cart attributes.
(function () {
  "use strict";

  var storageKey = "openai_oppref";
  var ttlMs = 7 * 24 * 60 * 60 * 1000;
  var params;
  var oppref;

  try {
    params = new URLSearchParams(window.location.search);
    oppref = params.get("oppref");
  } catch (error) {
    return;
  }

  if (oppref) {
    try {
      window.localStorage.setItem(
        storageKey,
        JSON.stringify({ value: oppref, ts: Date.now() })
      );
    } catch (error) {}
  }

  try {
    var raw = window.localStorage.getItem(storageKey);
    if (!raw) return;

    var stored = JSON.parse(raw);
    if (!stored || !stored.value || !stored.ts) return;

    if (Date.now() - Number(stored.ts) > ttlMs) {
      window.localStorage.removeItem(storageKey);
      return;
    }

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          oppref: stored.value,
        },
      }),
      keepalive: true,
    }).catch(function () {});
  } catch (error) {}
})();
